import { render, staticRenderFns } from "./ContactSelect.vue?vue&type=template&id=83ac0072&"
import script from "./ContactSelect.vue?vue&type=script&lang=ts&"
export * from "./ContactSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ac0072')) {
      api.createRecord('83ac0072', component.options)
    } else {
      api.reload('83ac0072', component.options)
    }
    module.hot.accept("./ContactSelect.vue?vue&type=template&id=83ac0072&", function () {
      api.rerender('83ac0072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/ContactSelect.vue"
export default component.exports